
export default class ItemType {
    /**
     * 
     * @param {string} id 
     * @param {string} name 
     * @param {string} attackType See AttackType.  Set to null if this is not a weapon.
     * @param {boolean} armor
     * @param {boolean} accessory 
     * @param {string} iconSpriteName The representative sprite for this type of item. We'll see if we need this.
     */
    constructor(id, name, attackType, armor, accessory, iconSpriteName) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
        /**
         * @constant
         * @type {string}
         */
        this.name = name;
        /**
         * See AttackType
         * @constant
         * @type {string}
         */
        this.attackType = attackType;
        /**
         * @constant
         * @type {boolean}
         */
        this.armor = armor;
        /**
         * @constant
         * @type {boolean}
         */
        this.accessory = accessory;
        /**
         * @constant
         * @type {string}
         */
        this.iconSpriteName = iconSpriteName;
    }
}